import { ITask } from "@rentiohq/shared-frontend/dist/types/task.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { EAssets } from "@rentiohq/web-shared-next/dist/assets";
import {
  // Chip,
  Stack,
  Divider,
  Icon,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  ListItemIcon,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { TaskListStyles } from "./TaskList.styles";

interface IProps {
  taskId?: number;
  tasks: ITask[];
}

export const TaskList = ({ tasks, taskId }: IProps) => {
  const navigate = useNavigate();

  const sx = TaskListStyles();

  if (tasks?.length === 0) {
    return (
      <Typography variant="h5" my={2}>
        {getLocalizedText("tasks.empty")}
      </Typography>
    );
  }

  return (
    <List component="nav" sx={{ pt: 0 }}>
      {tasks.map(task => {
        const { title, description, id } = task;

        return (
          <Fragment key={id}>
            <ListItemButton
              sx={sx.content.listItemBtn(task?.id === taskId)}
              onClick={() => navigate(`/tasks/${id}`)}
            >
              <ListItemIcon>
                <Icon path={EAssets.TasksIcon} width="24px" height="24px" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h6" sx={sx.content.title}>
                    {title}
                  </Typography>
                }
                secondary={
                  <Stack gap={2} direction="row" justifyContent="space-between">
                    <Typography variant="caption" sx={sx.content.description}>
                      {description}
                    </Typography>
                    {/* <Chip sx={sx.content.chip} /> */}
                  </Stack>
                }
              />
            </ListItemButton>
            <Divider sx={sx.content.divider} />
          </Fragment>
        );
      })}
    </List>
  );
};
